import { DateTime } from "luxon"

/*
 * Takes a JS Date (ex: 'Mon Jun 17 2024 13:58:59 GMT-0700 (Pacific Daylight Time)') and converts it to a presentable date (ex: "June 17, 2024")
 */
export const formatJSDateIntoReadableLabel = (jsDate: Date): string => {
    return DateTime.fromJSDate(jsDate).toFormat("MMMM dd, yyyy")
}
